export enum ECompetitionTab {
  MATCHES,
  RESULTS,
  STANDINGS,
}
